
import { Component, Vue } from "vue-property-decorator";
import { ILiveItem } from "@/api/types.d";
import NewsReleaseTep from "@/template/live/NewsRelease.vue";
console.log("这是开州1");
@Component
export default class NewsRelease extends NewsReleaseTep {
  itemClick(item: ILiveItem) {
    const url = location.href.split("/#/")[0];
    location.href =
      url +
      `/#/details/news-release-details?id=${item.id}&appId=${this.$route.query.appId}`;
  }
}
